import AcceptanceArtifactsContext from './List/AcceptanceArtifacts/AcceptanceArtifactsContext';
import AcceptancePoliciesContext from './List/AcceptancePolicies/AcceptancePoliciesContext';
import AcceptanceDocumentContextTemplate from './AcceptanceDocumentContextTemplate';

const AcceptanceLayout = () => (
  <>
    <AcceptancePoliciesContext />
    <AcceptanceDocumentContextTemplate>
      <AcceptanceArtifactsContext />
    </AcceptanceDocumentContextTemplate>
  </>
);

export default AcceptanceLayout;
